Librarian.Html5UploadWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["uploadClicked", "promptRename", "sendUploadRequest", "onAddFileClick", "onRemoveFileClick"],

    options: {
        id: "Html5UploadWindow",
        title: "upload_file",
        width: 315,
        height: 120,
        acceptType: null,
        complete: null,
        contentURL: null,
        allowedFileTypes: [],
        fileName: null,
        infoText: "",
        maxImageWidth: null,
        maxImageHeight: null
    },

    uploader: null,
    multiple: true,

    initialize: function (options) {
        this.setOptions(options);
        if (this.options.fileName) {
            this.multiple = false;
        }

        this.options.title = Librarian.Lang.getString(this.options.title);

        if (!this.options.contentURL) {
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/html5upload.html";
        }

        this.uploader = new Librarian.Html5Uploader({
            onComplete: function (files, successCount, failureCount) {
                Librarian.Utils.notifyUploadComplete(successCount, failureCount);

                if (typeof this.options.complete == "function")
                    this.options.complete(files);

                this.close();
            }.bind(this)
        });

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("selectFile");
        if (itemEl) {
            itemEl.set("multiple", this.multiple);

            if (typeof this.options.acceptType == "string") {
                itemEl.setAttribute("accept", this.options.acceptType);
            }
        }

        itemEl = this.getElement("submitButton");
        if (itemEl) {
            itemEl.addOnClick(this.uploadClicked);
        }

        itemEl = this.getElement("cancelButton");
        if (itemEl) {
            itemEl.addOnClick(this.close);
        }

        itemEl = this.getElement("upload-info-text");
        if (itemEl) {
            itemEl.set('text', this.options.infoText);
        }
    },

    uploadClicked: function() {
        var self = this;
        var fileEl = this.getElement("selectFile");
        if (!fileEl) {
            return;
        }

        var fileList = fileEl.files;

        if (fileList.length == 0) {
            Librarian.Utils.error(Librarian.Lang.getString("upload_select"), null, 4000);
            return;
        }

        if (self.validateFileTypes(fileList, fileEl)) {
            //If specified, file should be image and be smaller than these settings. Only supports single file uploads
            if (!this.multiple && (this.options.maxImageWidth || this.options.maxImageHeight)) {
                var img = new Image();
                img.onload = function() {
                    if ((self.options.maxImageWidth && this.width > self.options.maxImageWidth) ||
                        (self.options.maxImageHeight && this.height > self.options.maxImageHeight)) {
                        Librarian.Utils.error(Librarian.Lang.getString("upload_file_unapproved_filetype_error"),
                            null,
                            4000);
                        fileEl.set("value", "");
                        return false;
                    }

                    self.performUpload(fileList);

                };

                img.src = window.URL.createObjectURL(fileList[0]);

            } else {
                this.performUpload(fileList);
            }
        }
    },

    validateFileTypes: function(fileList, fileEl) {
        // if allowed file types are specified, verify all selected files are of approved type
        if (this.options.allowedFileTypes && this.options.allowedFileTypes.length > 0) {
            for (var i = 0; i < fileList.length; i++) {
                // if any files are not of approved type...
                if (this.options.allowedFileTypes.indexOf(fileList[i].type) === -1) {
                    // clear file selection
                    fileEl.set("value", "");

                    // show unapproved file type message
                    Librarian.Utils.error(Librarian.Lang.getString("upload_file_unapproved_filetype_error"), null, 4000);

                    // do not proceed
                    return false;
                }
            }
        }

        return true;
    },

    performUpload: function (fileList) {
        if (this.options.fileName) {
            var formData = new FormData();
            formData.append('file',
                fileList[0],
                this.options.fileName + ".png");
            fileList = [formData.get('file')];
        }

        // Show spinner
        this.coverEl = Librarian.Utils.showModalCover(this.contentWrapperEl);
        if (this.coverEl) {
            this.progressID = Librarian.Utils.showProgressImage(this.coverEl);
        }

        // upload files
        this.uploader.uploadFiles(fileList);
    }
});